import React, {useState, useEffect} from 'react';
import Welcome from '.';
import { CorporationSearchForm } from "@graffer-inc/graffer-ui";
import Http from '../../../http';
import Format from '../../../utils/format';
import ErrorHandler from '../../../utils/error-handler';
import Transition from '../../../utils/transition';
import Analytics from '../../../analytics';
import {connect} from "react-redux";
import {setLoginAccount} from "../../../redux/modules/user";
import {toast} from "react-toastify";
import * as store from "store";
import Const from "../../../constants";

const Main = ({setLoginAccount, stampSubmitter}) => {
  const [corporation, setCorporation] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false);
  useEffect(() => {
    Analytics.welcomeCompanySettingLanding(true);
  }, []);

  const updateCompany = async () => {
    setIsRequesting(true);
    await Http.updateCompany(
      {corporateId: corporation.id, companyName: corporation.name},
      async () => {
        setIsRequesting(false);
        Analytics.welcomeCompanySettingDone(true);
        await Http.fetchLoginAccount(async res => {
            const loginAccount = res.data.isAuthed ? res.data : null;
            setLoginAccount(loginAccount);
            if (!loginAccount) {
              store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
              await Http.logout();
              Transition.goToLogin();
            }
          },
          () => {
            store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
            Transition.goToLogin();
          });
        if (stampSubmitter) {
          toast.success('事前設定が完了しました。');
          Transition.goTo('/entries/new');
        } else {
          Transition.goTo('/welcome/stamp-submitter-setting');
        }
      },
      e => {
        setIsRequesting(false);
        ErrorHandler.common(e.response.status);
      },
    )
  };
  return (
    <Welcome stepName='自社設定'>
      <p className="has-text-weight-bold">あなたの所属する法人を教えてください。</p>
      <div style={{padding: '50px 0'}}>
        <CorporationSearchForm onSelect={c => setCorporation(c)}/>
        {
          corporation && (
            <div className="message" style={{marginTop: '25px', padding: '20px 10px', position: 'relative'}}>
              <span style={{position: 'absolute', top: -10, left: 0}} className="tag is-rounded is-dark">選択した法人</span>
              <p className="is-size-5 is-size-6-mobile has-text-weight-bold">{corporation.name}</p>
              <p className="is-size-7">法人番号: {corporation.id} / {Format.corporateNumber(corporation.id)}</p>
              <p className="is-size-7">本店所在地: {corporation.postal_code} {corporation.pref}{corporation.city}{corporation.street}</p>
            </div>
          )
        }
      </div>
      <div className="has-text-centered">
        <button
          className={`button has-text-weight-bold is-info is-fullwidth is-rounded ${isRequesting && 'is-loading'}`}
          onClick={updateCompany}
          disabled={!corporation || isRequesting}
        >
          登録して次に進む (1/2)
        </button>
        <p style={{paddingTop: '5px'}} className="is-size-7 has-text-grey">登録した情報は後からでも確認・変更できます</p>
      </div>
    </Welcome>
  )
};

export default connect(
  store => ({ stampSubmitter: store.user.stampSubmitter }),
  {setLoginAccount}
)(Main);